export class SurveyViewModel {
    public tenantName: string;
    public surveyKeys: number[];
}
